module.exports = "<button class=\"btn btn-link warning-button\"\n        type=\"button\"\n        ng-if=\"$ctrl.hasValue && !$ctrl.ngModel.is_analysis_valid\"\n        ng-click=\"$ctrl.openModal()\">\n    <span class=\"analysis-warning-icon\" aria-hidden=\"true\"></span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/analysis_warning.html
// module id = 679
// module chunks = 0